import styled from 'styled-components';
import { DatePicker } from 'antd';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
  max-width: 600px;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  color: #333;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  color: #333;
  margin-bottom: 8px;
`;

export const DateRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
  max-width: 320px;
  height: 36px !important;
  padding: 4px 11px !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px !important;
  background: white !important;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;

  .ant-picker-input > input {
    font-family: 'Poppins';
  }
`;

export const ExportButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 2px solid #d9d9d9;
  background: #2793db;
  color: white;
  border: none;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  padding: 8px 22px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s ease-in;

  &:hover:not(:disabled) {
    background-color: #006cbd;
  }

  &:active:not(:disabled) {
    background-color: #005a9e;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
